module.exports = __webpack_public_path__ + "static/media/heart.b5bfe30d.svg";